import { cn } from '@tameeni/shared-logic'
import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { useCurrentLocale } from '@/locales/client'
import { ChatWidgetClient } from '@/scripts'
import Footer from '@/features/main-layout/components/footer'
import Header from '@/features/main-layout/components/header'
import RenewalNotificationPopup from '@/features/policy-renewal/components/renewal-notification-popup'
import ProtectedRoutesErrorContainer from '@/components/ui/protected-routes-error-container'
import { InternalLoginModal } from '@/features/authentication'
import { getEnv } from '@/lib/config/runtime-env'

interface RootLayoutProps {
  readonly isMFE?: boolean
}

export default function RootLayout({ isMFE = false }: RootLayoutProps) {
  const locale = useCurrentLocale()

  useEffect(() => {
    document.documentElement.lang = locale
    document.documentElement.dir = locale === 'ar' ? 'rtl' : 'ltr'
  }, [locale])

  useEffect(() => {
    const { GTM_ID, GTM_ENABLED } = getEnv()
    if (typeof window === 'undefined' || !GTM_ID || !GTM_ENABLED) return
    if (document.querySelector('script[data-gtm]')) return
    const script = document.createElement('script')
    script.setAttribute('data-gtm', '')
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${GTM_ID}');`
    document.head.appendChild(script)
  }, [])

  return (
    <div className={cn('flex h-full flex-col')}>
      {!isMFE && <Header />}
      <main className='flex-1'>
        <ProtectedRoutesErrorContainer>
          <Outlet />
        </ProtectedRoutesErrorContainer>
        <RenewalNotificationPopup />
        <InternalLoginModal />
      </main>
      {!isMFE && <Footer />}
      <ChatWidgetClient />
    </div>
  )
}
